export const portfolioData = [
  {
    id: 1,
    title: "Clean Water Initiative",
    category: "wash",
    description: "Documentary on clean water access in rural communities",
    videoId: "_0y9p305o_g",
    videoUrl: "https://www.youtube.com/embed/_0y9p305o_g",
  },
  {
    id: 2,
    title: "Sanitation Awareness Campaign",
    category: "wash",
    description: "Educational video on proper sanitation practices",
    videoId: "vWThIJsIpOI",
    videoUrl: "https://www.youtube.com/embed/vWThIJsIpOI",
  },
  {
    id: 3,
    title: "Hand Hygiene Tutorial",
    category: "wash",
    description: "Step-by-step guide to proper handwashing techniques",
    videoId: "FdUc1ew7bow",
    videoUrl: "https://www.youtube.com/embed/FdUc1ew7bow",
  },
  {
    id: 4,
    title: "Community Outreach Program",
    category: "documentary",
    description: "Documentary on community development initiatives",
    videoId: "ipT5Ll1mRyk",
    videoUrl: "https://www.youtube.com/embed/ipT5Ll1mRyk",
  },
  {
    id: 5,
    title: "WASH in Schools",
    category: "wash",
    description: "Promoting WASH practices in educational institutions",
    videoId: "mnVEEI47TXI",
    videoUrl: "https://www.youtube.com/embed/mnVEEI47TXI",
  },
];

export const categories = [
  { id: "all", name: "All Projects" },
  { id: "wash", name: "WASH Content" },
  { id: "documentary", name: "Documentary" },
];
